import banners from './banners';
import { categories, sub_categories, super_categories } from './categories';
import chatBotQuestions from './chatBotQuestions';
import chats from './chats';
import conflicts from './conflicts';
import conflictsStatuses from './conflictsStatuses';
import favorites from './favorites';
import hangars from './hangars';
import invoices from './invoices';
import landing from './affiliation';
import orders from './orders';
import ordersStatuses from './orderStatuses';
import payment from './payment';
import products from './products';
import reviews from './reviews';
import sections from './sections';
import sourcing from './sourcing';
import specialOrderQuotes from './specialOrderQuotes';
import stats from './stats';
import users from './users';
import cars from './cars';
import carsOrders from './carsOrders';
import carsSections from './carsSections';

const api = {
  banners,
  categories,
  sub_categories,
  super_categories,
  sections,
  chatBotQuestions,
  chats,
  conflicts,
  conflictsStatuses,
  favorites,
  stats,
  hangars,
  invoices,
  orders,
  ordersStatuses,
  payment,
  products,
  specialOrderQuotes,
  users,
  reviews,
  sourcing,
  landing,
  cars,
  carsOrders,
  carsSections
};

export default api;
